import Box from "@cloudscape-design/components/box"
import Button from "@cloudscape-design/components/button"
import Popover, { type PopoverProps } from "@cloudscape-design/components/popover"
import SpaceBetween from "@cloudscape-design/components/space-between"
import { useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useNotifications } from "../../contexts/NotificationContext"
import NotificationCard from "../Notifications/NotificationCard"
import "./NotificationPopover.css"

const RECENT_LIMIT = 5

const NotificationPopover = () => {
  const { notifications, unreadCount, markAsRead } = useNotifications()
  const navigate = useNavigate()
  const popoverRef = useRef<PopoverProps.Ref>(null)
  const dismiss = () => popoverRef.current?.dismiss()

  const recent = notifications.slice(0, RECENT_LIMIT)

  return (
    <Popover
      ref={popoverRef}
      triggerType="custom"
      position="bottom"
      size="large"
      dismissButton={false}
      renderWithPortal
      header="Notifications"
      content={
        <SpaceBetween size="s">
          {recent.length === 0 ? (
            <Box color="text-status-inactive">No notifications</Box>
          ) : (
            <div className="notif-scroll">
              {recent.map((n) => (
                <NotificationCard
                  key={n.notification_id}
                  notification={n}
                  onMarkAsRead={markAsRead}
                  compact
                  onNavigate={dismiss}
                />
              ))}
            </div>
          )}
          <SpaceBetween size="xs" direction="horizontal">
            <Button
              variant="link"
              onClick={() => {
                dismiss()
                navigate("/notifications")
              }}
            >
              View all
            </Button>
          </SpaceBetween>
        </SpaceBetween>
      }
    >
      <span className="notif-bell">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="20" height="20">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        {unreadCount > 0 && <span className="notif-bell-badge">{unreadCount}</span>}
      </span>
    </Popover>
  )
}

export default NotificationPopover
